import IMApi from './_imApi';
import {FormMultiPart} from '@/apis/base/httpclient';
import {MSConstant} from '@/commons/wildcards';
import commonFn from '@/commons/commonFunction';
import httpclient from '../base/httpclient';
class ExportAPI extends IMApi {
  constructor() {
    super();
  }
  controllerName = 'Exports';
  /**
   * Xuất khẩu grid ra excel
   * @param {Array} columns dữ liệu cột
   * @param {Array} data dữ liệu dòng
   * @param {String} fileName tên file muốn lưu về
   * @returns Promise
   * NCPHUOC 11/08/2022
   */
  exportGrid(columns, data, fileName, header, mode = 0) {
    columns = columns.filter(x => x.dataField !== 'rowAction' && x.dataField !== 'rowState' && x.visible !== false);
    const colFormatEnums = columns.filter(x => x.formatType === MSConstant.FormatType.Enum);
    if (colFormatEnums.length > 0) {
      data.forEach(item => {
        colFormatEnums.forEach(col => {
          if (col.enum) {
            const text = commonFn.getEnumText(item[col.dataField], col.enum);
            item[`${col.dataField}_enum`] = text;
          }
        });
      });
    }
    const param = {
      fileName: fileName,
      header: header && header != '' ? header : null,
      column: JSON.stringify(columns),
      data: JSON.stringify(data),
      exportType: MSConstant.ExportType.ExportGrid,
      ExportMode: mode,
    };

    return httpclient.postAsync({
      data: param,
      url: this.getAPIUrl() + '',
    });
  }

  /**
   * Xuát khẩu excel nhiều sheet cột động
   * @param {*} columns list comlumns
   * @param {*} data
   * @param {*} fileName
   * @param {*} header
   * @returns
   * lttuan1 - 26.6.2023
   */
  exportGridMultipleDynamic(columns, data, fileName, header, mode = 0) {
    const param = {
      fileName: fileName,
      listHeader: header && header != [] ? header : null,
      column: JSON.stringify(columns),
      data: JSON.stringify(data),
      exportType: MSConstant.ExportType.exportGridMultipleDynamic,
      ExportMode: mode,
    };

    return httpclient.postAsync({
      data: param,
      url: this.getAPIUrl() + '',
    });
  }

  /**
   * Xuất khẩu tìm kiếm chứng từ
   * @param {*} columns
   * @param {*} data
   * @param {*} fileName
   * @returns
   * dqvinh 4.4.2023
   */
  exportGridSearchVoucher(columns, customParam, fileName, mode = 0) {
    columns = columns.filter(x => x.dataField !== 'rowAction' && x.dataField !== 'rowState' && x.visible !== false);
    const param = {
      fileName: fileName,
      column: JSON.stringify(columns),
      customParam: JSON.stringify(customParam),
      data: JSON.stringify([]),
      exportType: MSConstant.ExportType.ExportGridSearchVoucher,
      ExportMode: mode,
    };

    return httpclient.postAsync({
      data: param,
      url: this.getAPIUrl() + '',
    });
  }

  /**
   * Xuất khẩu mẫu nhập khẩu động
   * @param {*} importType tag import
   * @param {*} fileType loại template full hay basic(1 - full, 2 - basic)
   * @param {*} customParam truyền lên thêm param để custom export
   * @returns
   * NCPHUOC 16/08/2022
   * ptthuy2 28.08.2022: bổ sung thêm typeinfo
   * DVMINH 29/03/2024 Bổ sung thêm loại mode, 0 - mặc định ban đầu, 1 - có data truyền vào, 2 - dùng payload
   */
  exportTemplateImport(importType, fileType, fileNameRes, customParam, dataParam, mode = 0) {
    let importTypeInfo = fileType == 1 ? '_basic' : fileType == 2 ? '_full' : '';
    const param = {
      exportType: MSConstant.ExportType.ExportDynamicTemplateImport,
      data: importType,
      importTypeInfo: importType + importTypeInfo,
      fileType: fileType,
      fileName: fileNameRes,
      customParam: customParam,
      dataParam: dataParam,
      ExportMode: mode,
    };

    return httpclient.postAsync({
      data: param,
      url: this.getAPIUrl() + '',
    });
  }

  /**
   * Xuất khẩu mẫu excel
   * @returns
   * nmtuan4 28.2.2023
   */
  exportCustomTemplate(importType, exportData, fileNameRes) {
    const param = {
      exportType: MSConstant.ExportType.ExportDynamicTemplateImport,
      data: importType,
      exportData: JSON.stringify(exportData),
      fileName: fileNameRes,
    };

    return httpclient.postAsync({
      data: param,
      url: this.getAPIUrl() + '',
    });
  }

  /**
   * Xuất khẩu báo cáo tài chính
   * @param {*} p
   * @returns
   * NCPHUOC 20/09/2022
   */
  exportXmlFinance(p) {
    const param = {
      exportType: MSConstant.ExportType.ExportXmlFinance,
    };
    return httpclient.postAsync({
      data: Object.assign(p || {}, param),
      url: this.getAPIUrl() + '/XmlFinance',
    });
  }

  /**
   * Xuất khẩu báo cáo tài chính
   * @param {*} p
   * @returns
   * nmtuan4 6.10.2022
   */
  exportXmlFinanceSubmit(p) {
    const param = {
      exportType: MSConstant.ExportType.ExportXmlSubmitTax,
    };
    return httpclient.postAsync({
      data: Object.assign(p || {}, param),
      url: this.getAPIUrl() + '/XmlFinanceSubmit',
    });
  }

  /**
   * Xuất khẩu báo cáo mẫu merge
   * npcuong 05.01.2022
   */
  exportMergeReport(p) {
    const param = {
      exportType: MSConstant.ExportType.ExportMergeReport,
    };
    return httpclient.postAsync({
      data: Object.assign(p || {}, param),
      url: this.getAPIUrl() + '/MergeReport',
    });
  }

  /**
   * Xuất Excel thông tư 23
   * @param {*} data
   * @param {*} fileName
   * @returns
   * TPNAM 30.05.2023
   */
  exportGridMultiple(customParam, fileName, mode = 0) {
    const param = {
      fileName: fileName,
      customParam: JSON.stringify(customParam),
      data: JSON.stringify([]),
      exportType: MSConstant.ExportType.ExportGridMultipleSheet,
      ExportMode: mode,
    };
    return httpclient.postAsync({data: param, url: this.getAPIUrl() + ''});
  }

  /**
   * Xuất khẩu dữ liệu báo cáo dạng excel
   * @param {*} id session in báo cáo
   * @returns
   */
  exportReportExcelAsync(id) {
    const url = [this.getAPIUrl(), 'report-excel'].join('/');
    const data = id;
    return this.postAsync({url, data});
  }

  /**
   * Xuất khẩu dữ liệu
   * @returns
   * nmtuan4 28.2.2023
   */
  exportData(exportType, exportData, fileNameRes) {
    const param = {
      ExportType: exportType,
      ExportData: JSON.stringify(exportData),
      FileName: fileNameRes,
    };

    return httpclient.postAsync({
      data: param,
      url: this.getAPIUrl() + '',
    });
  }
  /**
   * Xuất khẩu grid ở popup thông báo phát sinh
   * @param {Array} columns dữ liệu cột
   * @param {Array} data dữ liệu dòng
   * @param {String} fileName tên file muốn lưu về
   * @returns Promise
   * NBTIN 20.12.2024
   */
  exportIncurredData(columns, data, fileName, header, mode = 0) {
    columns = columns.filter(x => x.dataField !== 'rowAction' && x.dataField !== 'rowState' && x.visible !== false);
    const colFormatEnums = columns.filter(x => x.formatType === MSConstant.FormatType.Enum);
    if (colFormatEnums.length > 0) {
      data.forEach(item => {
        colFormatEnums.forEach(col => {
          if (col.enum) {
            const text = commonFn.getEnumResource(item[col.dataField], col.enum);
            item[`${col.dataField}`] = text;
          }
        });
      });
    }
    const param = {
      fileName: fileName,
      header: header && header != '' ? header : null,
      column: JSON.stringify(columns),
      data: JSON.stringify(data),
      exportType: MSConstant.ExportType.ExportGrid,
      ExportMode: mode,
    };

    return httpclient.postAsync({
      data: param,
      url: this.getAPIUrl() + '',
    });
  }

  /**
   * Xuất khẩu dữ liệu khi đơn vị hết hạn
   * @param {*} thông tin dữ liệu cần xuất
   * @returns
   */
  exportExpiredData(param) {
    const url = [this.getAPIUrl(), 'export-expired-data'].join('/');
    const data = param;
    return this.postAsync({url, data});
  }
}

export default new ExportAPI();
